export default "__VITE_ASSET__BUCd3u$W__"